__turbopack_context__.v({
  "currentPrice": "RN3-4W_currentPrice",
  "insideWrapper": "RN3-4W_insideWrapper",
  "oldPrice": "RN3-4W_oldPrice",
  "priceWrapper": "RN3-4W_priceWrapper",
  "producerName": "RN3-4W_producerName",
  "productDetails": "RN3-4W_productDetails",
  "productName": "RN3-4W_productName",
  "productUnitDetails": "RN3-4W_productUnitDetails",
  "productWrapper": "RN3-4W_productWrapper",
  "trashIcon": "RN3-4W_trashIcon",
  "wrapper": "RN3-4W_wrapper",
});
